import React from 'react'

const SvgApple = props => (
  <svg viewBox='0 0 71.84 85.29' {...props}>
    <path d='M53.88 1.71a18.19 18.19 0 0 1-4.67 11.93C45.47 18 40.93 20.56 36 20.16a12 12 0 0 1-.1-1.62 18.69 18.69 0 0 1 4.96-12.06 19.43 19.43 0 0 1 6-4.53A18.09 18.09 0 0 1 53.79 0a16.32 16.32 0 0 1 .09 1.71zm16.46 64.76a46.22 46.22 0 0 1-4.59 8.24 41.29 41.29 0 0 1-5.91 7.14 11.41 11.41 0 0 1-7.59 3.34 19.05 19.05 0 0 1-7-1.67 20.06 20.06 0 0 0-7.55-1.67 20.7 20.7 0 0 0-7.76 1.67 20.74 20.74 0 0 1-6.71 1.76c-2.6.11-5.18-1-7.76-3.43a44 44 0 0 1-6.18-7.39 51.25 51.25 0 0 1-6.54-13A47.66 47.66 0 0 1 0 46a28.28 28.28 0 0 1 3.71-14.76 21.69 21.69 0 0 1 7.77-7.86 20.85 20.85 0 0 1 10.5-3 24.54 24.54 0 0 1 8.12 1.89c3.35 1.25 5.5 1.89 6.45 1.89.7 0 3.09-.74 7.14-2.23a23.48 23.48 0 0 1 9.71-1.72q10.77.87 16.15 8.5-9.63 5.88-9.55 16.36a18 18 0 0 0 5.92 13.57 19.21 19.21 0 0 0 5.9 3.87c-.45 1.38-.95 2.69-1.48 3.96z' />
  </svg>
)

export default SvgApple



// WEBPACK FOOTER //
// ./components/icons/experts/Apple.js